module.exports = __webpack_public_path__ + "static/media/speakerThree.82e06284.jpg";